export enum Fonts {
    NEWSREADER = "NewsReader",
    INTER = "Inter",
}